export default __webpack_public_path__ + "static/media/pr_c_15.0523c269.jpg";